angular.module('harriApp')
    .controller('PageNotFoundController',
        ["$scope", "$state", "hUser", "appLayoutViewService", "$rootScope",
            function ($scope, $state, hUser, appLayoutViewService, $rootScope) {

                var init = function () {
                    $scope.isEmployer = hUser.isEmployer();
                    $scope.isLoggedIn = hUser.isLoggedIn();
                    $scope.isTopLevelContext = hUser.isTopLevelContext();
                    appLayoutViewService.updateBrandTheme();
                };

                $scope.isSideBarExpanded = function () {
                    return appLayoutViewService.isSideBarExpanded();
                };

                $scope.getToggleSource = function () {
                    return appLayoutViewService.getToggleSource();
                };

                var userUpdatedEvent = $rootScope.$on('user_updated', function (event) {
                    init();
                });

                $scope.$on('$destroy', function () {
                    userUpdatedEvent();
                });

                init();

            }]);
